import { EscrowPartyTypeEnum } from 'src/graphql/schema';

import type { IClientChangesRequestedQuery } from 'src/graphql/actions/suggestChanges/clientChangesRequested.query';

const suggestionsPriority = {
  none: 0,
  agreement: 1,
  deposits: 2,
} as const;

type ISuggestionKey = keyof typeof suggestionsPriority;

export function getPendingSuggestionPriority(
  currentCompanyRole: EscrowPartyTypeEnum,
  changesRequested?: IClientChangesRequestedQuery,
): ISuggestionKey {
  let highest: ISuggestionKey = 'none';
  for (const key of Object.keys(suggestionsPriority) as ISuggestionKey[]) {
    const change =
      changesRequested?.clientChangesRequested?.[key as keyof typeof changesRequested.clientChangesRequested];
    if (
      change &&
      typeof change === 'object' &&
      change.status === 'pending' &&
      change.creator !== currentCompanyRole &&
      suggestionsPriority[key] > suggestionsPriority[highest]
    )
      highest = key;
  }
  return highest;
}
